import { AssetClassNameSetEvent, } from '../event/asset-class-name-set.event';
const assetClassNameSetProjections = {
    [AssetClassNameSetEvent.name]: (event, state) => ({
        ...state,
        ...event.getPayload(),
    }),
};
export default assetClassNameSetProjections;
//# sourceMappingURL=asset-class-name-set.projection.js.map